export default {
	init() {
    // JavaScript to be fired on all pages
},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    (function($) {

		/**
		* Copyright 2012, Digital Fusion
		* Licensed under the MIT license.
		* http://teamdf.com/jquery-plugins/license/
		*
		* @author Sam Sehnert
		* @desc A small plugin that checks whether elements are within
		*     the user visible viewport of a web browser.
		*     only accounts for vertical position, not horizontal.
		*/
		$.fn.visible = function(partial) {
		  	var $t 			= $(this),
		  	$w          	= $(window),
		  	viewTop       	= $w.scrollTop(),
		  	viewBottom    	= viewTop + $w.height(),
		  	_top          	= $t.offset().top,
		  	_bottom       	= _top + $t.height(),
		  	compareTop    	= partial === true ? _bottom : _top,
		  	compareBottom 	= partial === true ? _top : _bottom;
			return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
		};

	})(jQuery);

	/**	
	* Slide In (as you scroll down) Boxes with "slide-v" class
	* https://codepen.io/chriscoyier/pen/DjmJe
	*/

	var win = $(window);

	var allMods = $(".slide-v");

	allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
			el.addClass("already-visible"); 
		} 
	});

	win.scroll(function() {
		allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
			el.addClass("come-in"); 
		} 
		});
	});

	/**	
	* Toggle Open/close "more" link in title intro header 
	*/
   
	$('h1 .more').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('opened');
		$('h1.details').toggleClass('is-visible');
	});

    // responsive videos with https://github.com/toddmotto/fluidvids
    var $all_oembed_videos = $("iframe[src*='youtube']");
	
	$all_oembed_videos.each(function() {
		$(this).removeAttr('height').removeAttr('width').wrap( "<div class='embed-container'></div>" );
	});

    //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), 
    // don't forget to update this value as well
    var MQL = 1170;

	//primary navigation slide-in effect
	if($(window).width() > MQL) {
		var headerHeight = $('.cd-header').height();
		$(window).on('scroll',
		{
		previousTop: 0,
		}, 
		function () {
			var currentTop = $(window).scrollTop();
			//check if user is scrolling up
			if (currentTop < this.previousTop ) {
			//if scrolling up...
				if (currentTop > 0 && $('.cd-header').hasClass('is-fixed')) {
					$('.cd-header').addClass('is-visible');
				} else {
					$('.cd-header').removeClass('is-visible is-fixed');
				}
			} else {
			//if scrolling down...
			$('.cd-header').removeClass('is-visible');
				if( currentTop > headerHeight && !$('.cd-header').hasClass('is-fixed')) $('.cd-header').addClass('is-fixed');
			}
			this.previousTop = currentTop;
		});
	}

	//open/close primary navigation
	$('.cd-primary-nav-trigger').on('click', function(e){
		e.preventDefault();
		$('.cd-menu-icon').toggleClass('is-clicked'); 
		$('.cd-header').toggleClass('menu-is-open');
		$('.nav-menu').toggleClass('menu-is-open');
		//in firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
		if( $('.cd-primary-nav').hasClass('is-visible') ) {
			$('.cd-primary-nav').removeClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
				$('body').removeClass('overflow-hidden');
			});
		} else {
			$('.cd-primary-nav').addClass('is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',function(){
				$('body').addClass('overflow-hidden');
			});	
		}
	});

	// slick carousel for wp nav menu with thumbnails
	// featured post on wide screen
	$(function() {
	    $('.related-featured').slick({
			//slidesPerRow: 4,
			slidesToShow: 4,
			slidesToScroll: 4,
			infinite: true,
			speed: 500,
			//slide: 'li',
			arrows: true,
			prevArrow: '<a class="slick_arrow slick_prev arrow-left arrow-guttered"></a>',
			nextArrow: '<a class="slick_arrow slick_next arrow-right arrow-guttered"></a>',
			responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
	        // You can unslick at a given breakpoint now by adding:
	        // settings: "unslick"
	        // instead of a settings object
	        ],
	    });
    });


    // slick carousel for wp nav menu with thumbnails on home
    $(function() {
		$('body.front-page-data .thumb-nav').slick({
			//slidesPerRow: 3,
			slidesToShow: 3,
			slidesToScroll: 3,
			adaptiveHeight: false,
			infinite: true,
			speed: 500,
			//slide: 'li',
			prevArrow: '<a class="slick_arrow slick_prev arrow-left"></a>',
			nextArrow: '<a class="slick_arrow slick_next arrow-right"></a>',
			responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
	        // You can unslick at a given breakpoint now by adding:
	        // settings: "unslick"
	        // instead of a settings object
	        ],
	    });
    });

},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js